<div class='employee'>
  <asp-icon name="ic-20-utility-move.svg" width="1.2rem" class="drag-icon" cdkDragHandle></asp-icon>
  <img *ngIf='employee.avatar && employee.avatar !== "null"' class='profile-pic' [src]='employee.avatar' alt=""/>
  <span *ngIf="!employee.avatar || employee.avatar === 'null'" class='profile-pic-initial'>{{getEmployeeInitials()}}</span>
  <div class="employee-details">
    <span class='name'>{{employee.displayName}}</span>
    <span class='summary'>
      <span class='job-code' [title]="getTranslation(employee.title)">{{employeeJobCodeShort}} </span>
      <span class='flat-rate-hours'
            title="{{'teamManagement.flatRateHours' | translate}}"
            *ngIf="isTechnician">
        FR Hrs: <span class="hours">{{employee.flatRateHours || 0}}</span>
      </span>
    </span>
  </div>
</div>
